export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Adres serwera": "Server address",
        "Baza danych tego klienta jest nieaktualna.": "This client's database is outdated.",
        "Bazy danych": "Databases",
        "Data dodania": "Date added",
        "Dodaj klienta": "Add client",
        "Dodaj serwer": "Add server",
        "Dodanie klienta": "Adding client",
        "Dodanie serwera": "Adding server",
        "Edycja klienta": "Client edit",
        "Edycja serwera": "Server edit",
        "Edytuj": "Edit",
        "Hasło": "Password",
        "Hasło (Klucz ukryty)": "Password (Hidden key)",
        "Hasło użytkownika serwisowego": "Service user password",
        "Host dodatkowy": "Additional host",
        "Host główny": "Main host",
        "Katalog": "Catalog",
        "Klienci": "Clients",
        "Klient aktywny": "Active client",
        "Klient został dodany.": "Client has been added.",
        "Klient został usunięty.": "Client has been deleted.",
        "Klient został zaktualizowany.": "Client has been updated.",
        "Kontener plików": "File container",
        "Migracje": "Migrations",
        "Nazwa bazy danych": "Database name",
        "Nazwa klienta": "Client name",
        "Nazwa konta (Klucz dostępu)": "Account name (Access key)",
        "Nazwa serwera": "Server name",
        "Nazwa użytkownika": "Username",
        "Nazwa użytkownika serwisowego": "Service user name",
        "Nie udało się pobrać listy serwerów baz danych": "Failed to fetch database server list",
        "Nie udało się pobrać listy serwerów plików": "Failed to fetch file server list",
        "Port": "Port",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Powrót": "Back",
        "Region": "Region",
        "Serwer bazy danych": "Database server",
        "Serwer dostępny": "Server available",
        "Serwer plików": "File server",
        "Serwer został dodany.": "Server has been added.",
        "Serwer został usunięty.": "Server has been deleted.",
        "Serwer został zaktualizowany.": "Server has been updated.",
        "Serwery plików": "File servers",
        "Symbol klienta": "Client symbol",
        "System": "System",
        "Tryb konserwacji systemu": "System maintenance mode",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Only developer server. Do not use in production mode",
        "Typ serwera": "Server type",
        "Usługi": "Services",
        "Ustawienia zaawansowane": "Advanced settings",
        "Usuń": "Delete",
        "Wybierz serwer": "Select server",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back"
    }
};
